import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import MyMicrosite from '~/pages/MyMicrosite/MyMicrosite';

const MICROSITE_ROUTE: RouteObject[] = [
  {
    path: PATH.S(),
    element: <MyMicrosite />,
  },
];

export { MICROSITE_ROUTE };
